import React, { useEffect, useState, useMemo } from 'react';
import { getdata, updatedata, getdatanoauth } from "../../util/global";

const NoAuthPrescriptionView = () => {
  const [prescriptiondata, setprescriptiondata] = useState([]);
  const [patientdata, setpatientdata] = useState([]);
  const [usersetting, setusersetting] = useState(null);
  const [formdata, setformdata] = useState({ name: "", phonenumber: "",
    medicinedata: [{ medicine: "", dosage: "", instructions: "" }],
    notes: "", _id: null });
  const params = new URLSearchParams(window.location.search);
  

  const handleprint = () => {
    const content = document.getElementById('printarea').innerHTML;
    const frame = document.createElement('iframe');
    frame.style.display = 'none';
    document.body.appendChild(frame);
    const win = frame.contentWindow;
    
    win.document.write('<html><head><title>Prescription</title>');
    
    // 1. Point relative image URLs back to your web app's origin domain
    win.document.write(`<base href="${window.location.origin}">`);
    
    // 2. Force background graphics to print and add matching styling
    win.document.write(`
      <style>
        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          box-sizing: border-box;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
        }
        body {
          margin: 0;
          padding: 10px;
        }
        /* Style the table to match the clean modern modal UI */
        table { 
          width: 100%; 
          border-collapse: collapse; 
          margin-top: 10px;
        } 
        th {
          color: #4a5568;
          font-weight: 600;
          border-bottom: 2px solid #edf2f7;
          text-transform: uppercase;
          font-size: 13px;
          letter-spacing: 0.5px;
        }
        th, td { 
          padding: 12px 10px; 
          text-align: left; 
        }
        td {
          border-bottom: 1px solid #edf2f7;
          color: #2d3748;
          font-size: 14px;
        }
      </style>
    `);
    
    win.document.write('</head><body>');
    win.document.write(content);
    win.document.write('</body></html>');
    win.document.close();
    
    // 3. Small delay to ensure assets/background images are fetched before popping the window
    setTimeout(() => {
      win.print();
      document.body.removeChild(frame);
    }, 300);
  };

  const fetchdata = async () => {
    try {
      const [pdata, settingdata] = await Promise.all([
        getdatanoauth({ filter: { datatype: "prescriptiondata", _id: params.get("prescriptionid"), appname: window.APPSETTING.appname, _adminuserid: window.APPSETTING.adminuserid } }),
        getdatanoauth({ filter: { datatype: "usersettingdata", appname: window.APPSETTING.appname, _adminuserid: window.APPSETTING.adminuserid } })
      ]);

      if (pdata.length > 0) {
        setprescriptiondata(pdata.reverse());
        setformdata(pdata[0]);
      }

      if (settingdata.length > 0) {
        setusersetting(settingdata[0]);
      }
    } catch (err) { console.error(err); }
  };

  console.log("RENDER NOAUTHPRES");

  useEffect(() => { 
    fetchdata(); 
  }, []);

  const headerimg = "/css/appointment/prescription-header.png";
  const footerimg = "/css/appointment/prescription-footer.png";

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ width: '600px', position: 'relative' }}>
        
        {/* Fixed double onClick duplicate syntax here */}
        <button 
          className="close-btn" 
          onClick={() => window.close()} 
          style={{ position: 'absolute', top: '15px', right: '15px', fontSize: '24px' }}
        >
          &times;
        </button>

        <div id="printarea" style={{ padding: '20px' }}>
         
          <div style={{ backgroundImage: `url(${headerimg})`, height: '200px', backgroundSize: 'contain', backgroundRepeat: 'no-repeat' }}></div>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
            <div><strong>Patient:</strong> {formdata.name}</div>
            <div><strong>Date:</strong> {formdata.datetime}</div>
          </div>

          <table className="grid" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', padding: '10px' }}>medicine</th>
                <th style={{ textAlign: 'left', padding: '10px' }}>dosage</th>
                <th style={{ textAlign: 'left', padding: '10px' }}>instructions</th>
              </tr>
            </thead>
            <tbody>
              {formdata.medicinedata?.map((row, index) => (
                <tr key={index}>
                  <td style={{ padding: '10px' }}>{row.medicine}</td>
                  <td style={{ padding: '10px' }}>{row.dosage}</td>
                  <td style={{ padding: '10px' }}>{row.instructions}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {formdata.notes && (
            <div style={{ marginTop: '20px', paddingTop: '15px', borderTop: '1px solid #eee' }}>
              <strong>Notes</strong>
              <p style={{ margin: '8px 0 0', whiteSpace: 'pre-wrap', fontSize: '14px' }}>{formdata.notes}</p>
            </div>
          )}
         <div style={{ backgroundImage: `url(${footerimg})`, height: '200px', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}></div>
          
        </div>

        <div style={{ display: 'flex', gap: '10px', marginTop: '20px', justifyContent: 'flex-end', fontSize:'10px' }}>
          <a href="#"  onClick={handleprint} style={{fontSize:'10px' }}>Print</a>
        </div>
      </div>
    </div>
  );
};

export default NoAuthPrescriptionView;